import { createPortal } from 'react-dom';

import type { ChatToast } from '../chat-notifications.js';

export function NotificationToastRegion({
	dismiss,
	open,
	toasts,
}: {
	dismiss: (id: string) => void;
	open?: (toast: ChatToast) => void;
	toasts: ChatToast[];
}) {
	if (!toasts.length) return null;
	return createPortal(
		<aside
			aria-label="Chat notifications"
			aria-live="polite"
			className="notification-toast-region interparcel-page"
		>
			{toasts.map((toast) => (
				<div className={`chat-toast chat-toast-${toast.kind}`} key={toast.id} role="status">
					<div className="chat-toast-copy">
						<strong>{toast.title}</strong>
						<span>{toast.detail}</span>
					</div>
					<div className="chat-toast-actions">
						{open && (
							<button
								className="chat-toast-open"
								onClick={() => open(toast)}
								type="button"
							>
								Open chat
							</button>
						)}
						<button
							aria-label="Dismiss notification"
							className="chat-toast-dismiss"
							onClick={() => dismiss(toast.id)}
							type="button"
						>
							×
						</button>
					</div>
				</div>
			))}
		</aside>,
		document.body,
	);
}
